import { MaybeApiError } from "../hooks/useSWR";

type Options<D> = {
  data: D;
  method: "POST" | "PATCH" | "DELETE" | "GET" | "HEAD";
};

export async function fetchApi<R extends any, D extends any = any>(
  endpoint: string,
  { data, method }: Options<D>
) {
  return fetch(endpoint, {
    method,
    body: JSON.stringify(data),
    headers: {
      "Content-Type": "application/json",
      "x-ec-api": "v1"
    }
  }).then((res) => res.json() as Promise<MaybeApiError<R>>);
}
